// START_MODULE components_atoms_spinner_spinner_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';

import { Loader, LoaderWrapper } from './styled';

interface SpinnerProps {
  isCentered?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({
  isCentered = false,
}) => (
  <LoaderWrapper $isCentered={isCentered}>
    <Loader />
  </LoaderWrapper>
);

export default Spinner;

// END_MODULE components_atoms_spinner_spinner_tsx
